<!-- header for mobile -->
<app-task-process-page-header
  *ngIf="shouldShowHeader && !taskProcessContext.isLeavingPage"
  [taskProcessContext]="taskProcessContext"
  (backClicked)="onBackClicked($event)"></app-task-process-page-header>

<!-- yellow toast in top, showing "↓ new messages" -->
<div *ngIf="shouldShowUnreadMessagesBelowButton() && !isUserReadOnly" class="scroll-to-unread-messages-container">
  <ion-button (click)="onScrollToUnreadMessagesClicked()" class="scroll-button">
    <ion-icon name="arrow-down" slot="start"></ion-icon>
    {{ 'm/task-process/unread-messages-below' | translate }}
  </ion-button>
  <ion-button (click)="dismissUnreadMessages()" class="dismiss-button">
    <ion-icon name="close"></ion-icon>
  </ion-button>
</div>

<ion-content
  [fullscreen]="ionContentShouldBeFullscreen"
  [scrollEvents]="true"
  (ionScrollEnd)="onScrollEnd()"
  class="alc-bg-white-mosaic">
  <div [hidden]="infiniteScrollEnabled" class="alc-infinite-scroll-placeholder"></div>
  <ion-infinite-scroll
    (ionInfinite)="loadNextTasksOrActions($event)"
    [disabled]="!infiniteScrollEnabled"
    position="top"
    threshold="1px">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>
  <div #messagesContainer class="messages-container">
    <div *ngIf="noMoreMessages" class="no-older-message">{{ 'm/task-process/no-older-message' | translate }}</div>
    <div
      *ngFor="let chunk of chunks.loadedChunks; first as isFirstChunk; last as isLastChunk"
      [ngClass]="{ 'not-yet-inserted': isFirstChunk && isInsertingChunk }"
      class="chunk">
      <ng-container *ngFor="let message of chunk; last as isLastMessage; index as index; trackBy: trackById">
        <ng-container *ngIf="message">
          <div *ngIf="message.dayIndicatorFormat" class="bubble-day-indicator">
            <span>{{ message.datetime | dateTimezone: message.dayIndicatorFormat }}</span>
          </div>
          <div
            class="gbp-maybe-deleted-error"
            *ngIf="
              message.id === taskProcessContext.processedTaskOrActionId &&
              taskProcessContext.processedTaskInfo.updateDeletedStatusError
            ">
            <span
              [innerHTML]="
                taskProcessContext.processedTaskInfo.updateDeletedStatusError
                  | translate: { link: $any(message).externalUrl }
              "></span>
          </div>
          <div
            class="message-and-tags-container-and-editor"
            [ngClass]="{
              'processed-message': taskProcessContext.isProcessedTask(message.id),
              'processed-message-public':
                taskProcessContext.isProcessedTask(message.id) && taskProcessContext.isPublic()
            }">
            <div class="message-and-tags-container">
              <app-archive-and-other-actions
                *ngIf="taskProcessContext.isProcessedTask(message.id) && !isUserReadOnly"
                [taskProcessContext]="taskProcessContext"
                [processedTask]="message"
                [tagsContext]="taskProcessContext.tagsContext"></app-archive-and-other-actions>
              <app-message-in-task-process
                [attr.data-testid]="'message-' + index"
                [message]="message"
                [taskProcessContext]="taskProcessContext"
                [shouldScrollToTask]="isLastChunk && isLastMessage && !hasScrolledToProcessedTask"
                [isTaskProcessPageMessageList]="true"
                (scrolledToProcessedTask)="didScrollToProcessedTask()"
                (retrySending)="retrySendingAnswer($event)"></app-message-in-task-process>
              <div
                *ngIf="taskProcessContext.isProcessedTask(message.id) && hasPreviousOnHoldNotByBot() && !isUserReadOnly"
                class="previous-on-hold-warning-container">
                <ion-button (click)="scrollToPreviousOnHold()" color="warning">
                  <ion-icon name="arrow-up" slot="end"></ion-icon>
                  {{ 'm/task-process/previous-on-hold/warning-button' | translate }}
                </ion-button>
              </div>
              <app-select-tags
                *ngIf="
                  taskProcessContext.isProcessedTask(message.id) && !taskProcessContext.isCRMMode && !isUserReadOnly
                "
                [tagsContext]="taskProcessContext.tagsContext"></app-select-tags>
            </div>
          </div>

          <ng-container
            *ngIf="
              taskProcessContext.isPrivate() &&
              taskProcessContext.isProcessedTask(message.id) &&
              !taskProcessContext.isTheLastFromUser &&
              !taskProcessContext.isLeavingPage &&
              !isUserReadOnly
            "
            [ngTemplateOutlet]="summary"></ng-container>

          <div
            *ngIf="taskProcessContext.isPublic() && taskProcessContext.isProcessedTask(message.id) && !isUserReadOnly"
            class="inline-editor">
            <ng-container *ngTemplateOutlet="editor"></ng-container>
          </div>
        </ng-container>
      </ng-container>
      <div *ngIf="chunks.chunkNeedsNewMessagesSeparator(chunk)" class="new-messages-separator-container">
        <div class="new-messages-separator">
          <div class="line"></div>
          <div class="text">{{ 'm/task-process/unread-messages-below' | translate }}</div>
        </div>
      </div>
    </div>

    <ng-container
      *ngIf="
        taskProcessContext.isPrivate() &&
        taskProcessContext.isTheLastFromUser &&
        !taskProcessContext.isLeavingPage &&
        !isUserReadOnly
      "
      [ngTemplateOutlet]="summary"></ng-container>
  </div>

  <!-- overlay arrows to scroll to message when it's out of screen -->
  <ion-button
    *ngIf="isProcesedMessageAboveViewport"
    (click)="taskProcessContext.scrollToProcessedTask()"
    slot="fixed"
    fill="clear"
    class="scroll-up-to-processed-message-button">
    <ion-icon src="assets/img/arrow-up-circle.svg" slot="icon-only"></ion-icon>
  </ion-button>
  <ion-button
    *ngIf="isProcesedMessageBelowViewport"
    (click)="taskProcessContext.scrollToProcessedTask()"
    slot="fixed"
    fill="clear"
    class="scroll-down-to-processed-message-button">
    <ion-icon src="assets/img/arrow-down-circle.svg" slot="icon-only"></ion-icon>
  </ion-button>
</ion-content>

<!-- if we reply in private to a public message, we still use the inline editor 
     (hence the isPrivate() below, instead of isReplyingInPrivate() ) -->
<ion-footer *ngIf="taskProcessContext.isPrivate() && !taskProcessContext.isLeavingPage && !isUserReadOnly">
  <ng-container *ngTemplateOutlet="editor"></ng-container>
</ion-footer>
<ng-template #editor>
  <app-answer-editor
    *ngIf="hasAnswerEditor(); else allowedActionsWithoutEditor"
    [taskProcessContext]="taskProcessContext"
    (sendAnswer)="sendAnswer($event)"></app-answer-editor>

  <ng-template #allowedActionsWithoutEditor>
    <div class="no-answer-editor">
      <!-- A customer has the possibility to close a conversation on Apple messages -->
      <div *ngIf="taskProcessContext.isConversationClosedBS.value; else allowedActions">
        {{ 'm/task-process/task-actions-log/conversation-closed' | translate }}
      </div>
      <ng-template #allowedActions>
        <ion-button *ngIf="hasProcessReadOnlyButton()" (click)="processMessage()">
          {{ 'm/task-process/read-only/process-this-message' | translate }}
        </ion-button>
        <ion-button *ngIf="hasStealButton()" (click)="confirmThenStealThenProcessMessage()">
          {{ 'm/task-process/task-actions-log/steal-this-message' | translate }}
        </ion-button>
        <ion-button *ngIf="shouldOnlyAllowArchiving()" (click)="archiveTask()"> {{ archiveButtonMessage }} </ion-button>
        <div *ngIf="taskProcessContext.isLatestTaskTooOldForReply && !canStealMessage()">
          {{ taskProcessContext.tooOldForReplyTranslationKey | translate }}
        </div>
        <div *ngIf="taskProcessContext.isLatestTaskTooOldForReply && canStealMessage()">
          {{ 'm/task-process/task-actions-log/steal-old-message' | translate }}
          <div class="steal-old-message">
            <ion-button (click)="stealThenProcessMessage()">
              {{ 'm/task-process/task-actions-log/steal-this-message' | translate }}
            </ion-button>
          </div>
        </div>
      </ng-template>
    </div>
  </ng-template>
  <div>
    <!-- trick ion-toolbar into not setting padding-bottom to the bottom safe area (the corresponding rule is set with :last-child) -->
  </div>
</ng-template>

<ng-template #summary>
  <app-ai-summary
    [taskProcessContext]="taskProcessContext"
    [nbMessages]="chunks.loadedChunks[0].length || 0"></app-ai-summary>
</ng-template>
